import { styled } from '@linaria/react';

import { uiToken } from '~/shared/constants/uiToken';
import { Typography } from '~/shared/ui/Typography/Typography';

export const Root = styled.div`
  display: flex;
  width: 100%;
  gap: 8px;
  padding: 16px;
  background: ${uiToken.color.background.transparent};
  border: ${uiToken.color.border.default} 0.5px solid;
  border-radius: 12px;
  align-items: center;
`;

export const CardData = styled(Typography.Paragraph)`
  font-weight: 400;
  line-height: 20px;
`;
